export default "__VITE_ASSET__CkBT$R3H__"